import React from 'react'
// import './ComplainLottie.css'
import Lottie from 'react-lottie';
import * as animationData from './ThankYou.json';
const ThankYou = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    return (
        <>
            <div className='thank-you'>
                <Lottie className=" lotties"
                    options={defaultOptions}
                />
            </div>
        </>
    )
}

export default ThankYou